import readlangClient from "readlangClient";

// set up backbone sync
const methodMap = {
  create: "POST",
  update: "PUT",
  patch: "PATCH",
  delete: "DELETE",
  read: "GET",
};

export default (method, model, options) =>
  new Promise((resolve, reject) => {
    let url;
    if (model.urlRoot) {
      if (method === "create") {
        url = model.urlRoot;
      } else {
        url = model.urlRoot + "/" + model.get("_id");
      }
    } else {
      url = typeof model.url === "function" ? model.url() : model.url;
    }

    let reqData = {};

    if (method === "create" || method === "update") {
      reqData = model.toJSON();
    } else if (method === "patch") {
      // TODO: attrs should probably be 'data',
      //       check code and alter
      reqData = options.attrs;
    } else if (method === "read") {
      reqData = options.data;
    }

    readlangClient.request(
      methodMap[method],
      url,
      reqData,
      (data) => {
        if (method === "create" && data.upserted) {
          model.set("_id", data.upserted);
        }
        if (method === "create" && data._id) {
          model.set("_id", data._id);
        }
        if (options && options.success) {
          options.success(data);
        }
        resolve(data);
      },
      (data) => {
        if (options.error) {
          options.error(data);
        } else {
          console.error(
            "failed request: " +
              url +
              "\n" +
              data.status +
              " " +
              data.statusText +
              ":\n\n" +
              data.responseText
          );
        }
        reject(data);
      }
    );
  });
